module.exports = __webpack_public_path__ + "static/media/wheel-locks.0ac233d8.svg";